/**
 * 航班计划邮件相关API
 */

import apiClient from "./axios";

/**
 * 发送航班计划确认邮件 V2 (使用UniversalMailService)
 * @param {number} scheduleId - 计划ID
 * @param {Object} emailData - 邮件数据
 * @returns {Promise} API响应 - 返回 {success: boolean, message: string, data: {...}}
 */
export const sendScheduleConfirmationEmailV2 = async (scheduleId, emailData) => {
    try {
        const response = await apiClient.post(`/v1/schedules/${scheduleId}/send-confirmation-email-v2`, emailData);
        return response.data;
    } catch (error) {
        console.error("发送计划确认邮件V2失败:", error);
        throw error;
    }
};

/**
 * 发送航班计划发布邮件 V2 (使用UniversalMailService)
 * @param {number} scheduleId - 计划ID
 * @param {Object} emailData - 邮件数据
 * @returns {Promise} API响应 - 返回 {success: boolean, message: string, data: {...}}
 */
export const sendSchedulePublishEmailV2 = async (scheduleId, emailData) => {
    try {
        const response = await apiClient.post(`/v1/schedules/${scheduleId}/send-publish-email-v2`, emailData);
        return response.data;
    } catch (error) {
        console.error("发送计划发布邮件V2失败:", error);
        throw error;
    }
};

/**
 * 发送航班计划群发邮件（异步拆分发送）
 * @param {number} scheduleId - 计划ID
 * @param {Object} emailData - 邮件数据
 * @param {boolean} splitSending - 是否拆分发送
 * @param {number} sendInterval - 发送间隔（秒）
 * @returns {Promise} API响应 - 返回 {success: boolean, message: string, data: {...}}
 */
export const sendScheduleBulkEmail = async (scheduleId, emailData, splitSending = true, sendInterval = 1.0) => {
    try {
        const response = await apiClient.post(`/v1/schedules/${scheduleId}/send-publish-bulk-email-v2?split_sending=${splitSending}&send_interval=${sendInterval}`, emailData);
        return response.data;
    } catch (error) {
        console.error("发送计划群发邮件失败:", error);
        throw error;
    }
};

/**
 * 批量发送航班计划确认邮件 V2 (使用UniversalMailService)
 * @param {Object} emailData - 批量邮件数据
 * @param {Array} emailData.schedule_ids - 计划ID数组
 * @param {string} emailData.to - 收件人
 * @param {string} [emailData.cc] - 抄送人
 * @param {string} [emailData.bcc] - 密送人
 * @param {string} emailData.subject - 邮件主题
 * @param {string} emailData.rendered_html - 前端渲染的HTML内容
 * @param {Object} emailData.content_block_context - 内容块上下文
 * @param {Array} [emailData.attachments] - 附件列表
 * @returns {Promise} API响应 - 返回 {success: boolean, message: string, data: {...}}
 */
export const sendBatchScheduleConfirmationEmailV2 = async (emailData) => {
    try {
        const response = await apiClient.post(`/v1/schedules/batch-send-confirmation-email-v2`, emailData);
        return response.data;
    } catch (error) {
        console.error("批量发送计划确认邮件V2失败:", error);
        throw error;
    }
};

/**
 * 批量发送航班计划发布邮件 V2 (使用UniversalMailService)
 * @param {Object} emailData - 批量邮件数据
 * @param {Array} emailData.schedule_ids - 计划ID数组
 * @param {string} emailData.to - 收件人
 * @param {string} [emailData.cc] - 抄送人
 * @param {string} [emailData.bcc] - 密送人
 * @param {string} emailData.subject - 邮件主题
 * @param {string} emailData.rendered_html - 前端渲染的HTML内容
 * @param {Object} emailData.content_block_context - 内容块上下文
 * @param {Array} [emailData.attachments] - 附件列表
 * @returns {Promise} API响应 - 返回 {success: boolean, message: string, data: {...}}
 */
export const sendBatchSchedulePublishEmailV2 = async (emailData) => {
    try {
        const response = await apiClient.post(`/v1/schedules/batch-send-publish-email-v2`, emailData);
        return response.data;
    } catch (error) {
        console.error("批量发送计划发布邮件V2失败:", error);
        throw error;
    }
};

export default {
    sendScheduleConfirmationEmailV2,
    sendSchedulePublishEmailV2,
    sendScheduleBulkEmail,
    sendBatchScheduleConfirmationEmailV2,
    sendBatchSchedulePublishEmailV2,
};
